/* ============================================================
   ei-search-overlay.js — Chantier 3 (refonte nav, section customisable 07-12)
   Pop-up recherche : focus clavier immédiat + suggestions live
   (produits avec vignette + nom [texte tapé en gras] + type + PRIX / articles / pages)
   via /search/suggest.json. Bouton ✕ pour effacer.
   Libellés + nombre de résultats lus depuis les réglages Customizer (data-*).
   ============================================================ */
(function () {
  'use strict';
  var overlay = document.getElementById('ei-search-overlay');
  if (!overlay) return;
  var input = document.getElementById('ei-search-input');
  var form = document.getElementById('ei-search-form');
  var cancelBtn = document.getElementById('ei-search-cancel');
  var clearBtn = document.getElementById('ei-search-clear');
  var idle = document.getElementById('ei-search-idle');
  var results = document.getElementById('ei-search-results');
  var timer = null;
  var lastQuery = '';       /* dernière requête tapée — envoyée avec les events de clic */
  var lastSource = 'direct'; /* d'où la recherche a été ouverte (header / burger_menu) */

  /* Voir la note dans ei-burger-menu.js : la couche de données conserve les valeurs
     d'un push à l'autre, on remet donc à zéro tous les params EI à chaque event. */
  var EI_PARAMS = ['ei_source', 'ei_action', 'ei_product', 'ei_query', 'ei_result_type', 'ei_rayon', 'ei_position', 'ei_sav_item'];

  function push(params) {
    var payload = {};
    for (var i = 0; i < EI_PARAMS.length; i++) payload[EI_PARAMS[i]] = undefined;
    for (var k in params) payload[k] = params[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  var d = overlay.dataset;
  var L = {
    products: d.lblProducts || 'Produits',
    articles: d.lblArticles || 'Articles & recettes',
    pages: d.lblPages || 'Pages',
    seeall: d.lblSeeall || 'Voir tous les résultats pour',
    zero: d.lblZero || 'Aucun résultat pour'
  };
  var LIMIT = parseInt(d.limit || '6', 10);

  /* ── LOT 2, 05-09-2026 — reglages Customizer supplementaires ──────────────
     PROD_LIMIT plafonne les suggestions PRODUIT (3 a 6). Attention : le
     parametre resources[limit] de Shopify s'applique PAR TYPE, pas au total —
     avec 6, l'API peut rendre 6 produits + 6 articles + 6 pages, soit 18
     lignes. Le plafond ci-dessous borne la seule liste qui compte pour l'achat.
     ────────────────────────────────────────────────────────────────────── */
  var PROD_LIMIT = parseInt(d.prodLimit || '6', 10);
  if (PROD_LIMIT < 3) PROD_LIMIT = 3;
  if (PROD_LIMIT > 6) PROD_LIMIT = 6;
  var SHOW_PRODUCTS = d.showProducts !== 'false';
  var SHOW_PRICE = d.showPrice !== 'false';
  var HIDE_SOLD_OUT = d.hideSoldOut === 'true';
  var LBL_SOLD_OUT = d.lblSoldOut || 'Épuisé';

  /* Disponibles d'abord, epuises ensuite, puis on coupe au plafond.
     Le tri est STABLE : a disponibilite egale, l'ordre de pertinence de
     Shopify est conserve. `available` est bien rendu par suggest.json —
     verifie le 03-09-2026 sur « artichaut » et « genovese ». */
  function triDispo(list) {
    var dispo = [], epuises = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].available === false) epuises.push(list[i]);
      else dispo.push(list[i]);
    }
    if (HIDE_SOLD_OUT) return dispo.slice(0, PROD_LIMIT);
    return dispo.concat(epuises).slice(0, PROD_LIMIT);
  }

  function toggleClear() { if (clearBtn) clearBtn.hidden = !(input && input.value); }

  /* ── 05-09-2026 — images de l'etat vide ───────────────────────────────────
     La pop-up est en `position: fixed` : `loading="lazy"` n'y retient rien,
     le navigateur telecharge a y=0 des le chargement de la page. Les URL
     attendent donc dans `data-eis-src` (voir sections/ei-search-overlay.liquid)
     et ne sont posees qu'ici, a la premiere ouverture. Cout avant ouverture : 0.
     ────────────────────────────────────────────────────────────────────── */
  var idleImgsPosees = false;
  function poserImagesIdle() {
    if (idleImgsPosees) return;
    idleImgsPosees = true;
    var imgs = overlay.querySelectorAll('img[data-eis-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].getAttribute('data-eis-src');
      imgs[i].removeAttribute('data-eis-src');
    }
  }

  function open(opts) {
    poserImagesIdle();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ei-burger-open');
    void overlay.offsetHeight; /* force le recalcul de style : champ réellement visible AVANT le focus */
    /* Focus SYNCHRONE dans le geste utilisateur -> iOS ouvre le clavier au 1er tap.
       (un setTimeout casse le geste : iOS refuse alors d'ouvrir le clavier) */
    if (input) {
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      /* Backup après l'animation, au cas où le focus synchrone n'ait pas pris */
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 250);
    }
    toggleClear();
    lastSource = (opts && opts.source) || 'direct';
    push({ event: 'ei_search_open', ei_source: lastSource });
  }
  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ei-burger-open');
  }

  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function euro(v) { var n = parseFloat(v); return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + '€'; }
  function fmtPrice(price, compare) {
    var p = euro(price); if (!p) return '';
    var c = parseFloat(compare);
    if (c && c > parseFloat(price)) return '<s>' + euro(compare) + '</s> ' + p;
    return p;
  }
  function highlight(title, q) {
    var t = esc(title);
    if (!q) return t;
    var qe = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    try { return t.replace(new RegExp('(' + qe + ')', 'ig'), '<b>$1</b>'); } catch (e) { return t; }
  }
  function thumbImg(url) {
    if (!url) return '<span class="ei-search-thumb-empty"></span>';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return '<img src="' + url + sep + 'width=120" alt="" loading="lazy">';
  }

  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var prod = r.products || [], art = r.articles || [], pg = r.pages || [];
    var html = '';
    lastQuery = q;

    prod = SHOW_PRODUCTS ? triDispo(prod) : [];
    if (prod.length) {
      html += '<p class="ei-search-sec">' + esc(L.products) + '</p>';
      prod.forEach(function (p, i) {
        var price = SHOW_PRICE ? fmtPrice(p.price, p.compare_at_price_max) : '';
        var epuise = p.available === false;
        var sub = p.type ? '<span class="ei-search-row-sub">' + esc(p.type) + '</span>' : '';
        if (epuise) sub += '<span class="ei-search-row-epuise">' + esc(LBL_SOLD_OUT) + '</span>';
        html += '<a class="ei-search-row' + (epuise ? ' is-epuise' : '') + '" href="' + p.url + '" data-ei-action="search_result_click"'
             + ' data-ei-type="product" data-ei-handle="' + esc(p.handle || '') + '" data-ei-position="' + (i + 1) + '">'
             + '<span class="ei-search-thumb">' + thumbImg(p.image) + '</span>'
             + '<span class="ei-search-row-info"><span class="ei-search-row-title">' + highlight(p.title, q) + '</span>' + sub + '</span>'
             + (price ? '<span class="ei-search-row-price">' + price + '</span>' : '') + '</a>';
      });
    }
    if (art.length) {
      html += '<p class="ei-search-sec">' + esc(L.articles) + '</p>';
      art.forEach(function (a, i) {
        html += '<a class="ei-search-row" href="' + a.url + '" data-ei-action="search_result_click"'
             + ' data-ei-type="article" data-ei-handle="' + esc(a.handle || '') + '" data-ei-position="' + (i + 1) + '">'
             + '<span class="ei-search-thumb' + (a.image ? '' : ' ei-search-thumb--art') + '"'
             + (a.image ? '>' : ' aria-hidden="true">')
             + (a.image ? thumbImg(a.image) : '📖') + '</span>'
             + '<span class="ei-search-row-info"><span class="ei-search-row-title">' + highlight(a.title, q) + '</span></span></a>';
      });
    }
    if (pg.length) {
      html += '<p class="ei-search-sec">' + esc(L.pages) + '</p>';
      pg.forEach(function (p, i) {
        html += '<a class="ei-search-row" href="' + p.url + '" data-ei-action="search_result_click"'
             + ' data-ei-type="page" data-ei-handle="' + esc(p.handle || '') + '" data-ei-position="' + (i + 1) + '">'
             + '<span class="ei-search-thumb ei-search-thumb--page" aria-hidden="true">📄</span>'
             + '<span class="ei-search-row-info"><span class="ei-search-row-title">' + highlight(p.title, q) + '</span></span></a>';
      });
    }
    if (!html) {
      /* LOT 2 : une frappe qui ne trouve rien est une intention perdue —
         on la trace, sinon elle n'existe nulle part. */
      push({ event: 'ei_search_zero_result', search_term: q, ei_query: q, ei_source: lastSource });
      html = '<div class="ei-search-zero"><p class="ei-search-zero-t">' + esc(L.zero) + ' « ' + esc(q) + ' »</p>'
           + '<a class="ei-search-zero-cta" href="/search?q=' + encodeURIComponent(q) + '">' + esc(L.seeall) + '</a></div>';
    } else {
      html += '<a class="ei-search-all" href="/search?q=' + encodeURIComponent(q) + '" data-ei-action="search_see_all">' + esc(L.seeall) + ' « ' + esc(q) + ' » →</a>';
    }
    results.innerHTML = html;
  }

  function doSearch(q) {
    if (!q || q.length < 2) { results.innerHTML = ''; if (idle) idle.style.display = ''; return; }
    if (idle) idle.style.display = 'none';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=' + LIMIT,
      { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d2) { render(d2, q); })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      toggleClear();
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { doSearch(q); }, 200);
    });
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      toggleClear();
      results.innerHTML = '';
      if (idle) idle.style.display = '';
      input.focus();
    });
  }

  overlay.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('.ei-search-chip') : null;
    if (chip) { input.value = chip.getAttribute('data-q'); toggleClear(); input.focus(); doSearch(input.value.trim()); return; }
    if (e.target.closest && e.target.closest('.ei-search-row, .ei-search-zero-cta, .ei-search-all')) { close(); }
  });

  if (cancelBtn) cancelBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  /* ── LOT 2, 05-09-2026 — navigation clavier dans les suggestions ──────────
     Avant : seule la touche Echap etait geree. Les fleches ne faisaient rien,
     ce qui rendait la liste inatteignable sans souris ni tabulation longue.
     Bas/Haut deplacent le focus reel (pas une simple classe visuelle) : le
     lecteur d'ecran annonce donc la ligne, et Entree suit le lien nativement.
     ────────────────────────────────────────────────────────────────────── */
  function rows() {
    return results ? Array.prototype.slice.call(results.querySelectorAll('.ei-search-row, .ei-search-all, .ei-search-zero-cta')) : [];
  }
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var list = rows();
    if (!list.length) return;
    e.preventDefault();
    var pos = list.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') {
      pos = (pos === -1) ? 0 : pos + 1;
      if (pos >= list.length) { if (input) input.focus(); return; }
    } else {
      if (pos <= 0) { if (input) input.focus(); return; }
      pos = pos - 1;
    }
    list[pos].focus();
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.js-search-destop, [data-ei-search-open]') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open({ source: t.getAttribute('data-ei-source') || 'header' });
  }, true);

  /* Tracking GA4 des clics dans les résultats.
     Les liens portaient déjà data-ei-action mais AUCUN listener ne les lisait
     -> ei_search_result_click / ei_search_see_all ne partaient jamais (fix 02-08-2026).
     Écoute sur l'overlay : les résultats sont réinjectés en innerHTML à chaque frappe. */
  overlay.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-ei-action]') : null;
    if (!el) return;
    var action = el.getAttribute('data-ei-action');
    var payload = {
      event: 'ei_' + action,
      ei_source: lastSource,
      ei_action: action,
      ei_query: lastQuery
    };
    if (el.getAttribute('data-ei-handle')) payload.ei_product = el.getAttribute('data-ei-handle');
    if (el.getAttribute('data-ei-type')) payload.ei_result_type = el.getAttribute('data-ei-type');
    if (el.getAttribute('data-ei-position')) payload.ei_position = parseInt(el.getAttribute('data-ei-position'), 10);
    push(payload);
  });

  window.EISearchOverlay = { open: open, close: close };
})();
